import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Cube } from "@phosphor-icons/react";
import { LOGO } from "@/components/Navbar";

export default function Login() {
  const { login, apiError } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const dest = (role) => (role === "admin" ? "/admin" : role === "seller" ? "/seller" : (loc.state?.from || "/account"));

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      nav(dest(u.role));
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-[calc(100vh-4rem)] lg:grid-cols-2">
      <div className="hidden flex-col justify-between bg-navy p-12 text-white lg:flex bp-grid">
        <Link to="/" className="flex items-center gap-2">
          <span className="inline-flex rounded-md bg-white px-3 py-2"><img src={LOGO} alt="SparesHub" className="h-7 w-auto" /></span>
        </Link>
        <div>
          <h2 className="font-display text-4xl font-black leading-tight tracking-tighter">Verified lots.<br />Sanitized data.<br /><span className="text-brand">Escrow closure.</span></h2>
          <p className="mt-4 max-w-sm text-white/60">Log in to download sanitized inventory files and express interest in bulk liquidation lots.</p>
        </div>
        <p className="text-xs text-white/40">Managed B2B spare-parts liquidation · ₹ INR</p>
      </div>

      <div className="flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          <h1 className="font-display text-3xl font-black tracking-tight text-navy">Log in</h1>
          <p className="mt-2 text-muted-foreground">New to SparesHub? <Link to="/register" className="font-semibold text-brand hover:underline">Create an account</Link></p>

          {err && <div className="mt-6 rounded-sm border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm text-destructive" data-testid="login-error">{err}</div>}

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label>Email</Label>
              <Input data-testid="login-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 rounded-sm" placeholder="you@company.com" />
            </div>
            <div>
              <Label>Password</Label>
              <Input data-testid="login-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5 rounded-sm" placeholder="••••••••" />
            </div>
            <Button type="submit" disabled={loading} className="h-11 w-full rounded-sm bg-brand text-base font-semibold text-white hover:bg-brand-hover" data-testid="login-submit">{loading ? "Signing in..." : "Log in"}</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
